module.exports = __webpack_public_path__ + "static/media/arrowdown.7016cb36.svg";